module.exports = __webpack_public_path__ + "static/media/PAK-TURK-SCHOOL-LOGO-FINAL.878b653a.jpg";